import { withLDConsumer } from 'launchdarkly-react-client-sdk';
import NavSidebar from './nav-sidebar';

export default withLDConsumer()(NavSidebar);
